import { type FC } from "react";

import type { FlowCustomComponentProps } from "@/shared/constants/flowTypes";

import { AttorneyCta } from "./AttorneyCta";

export const WillConditionWarningScreen: FC<FlowCustomComponentProps> = () => {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-1">
        <p className="font-sans text-xl font-semibold leading-[30px]">
          That's okay, you'll need an extra statement for this document
        </p>
        <p className="text-sm text-secondary tracking-[-0.28px]">
          Courts are strict about physical changes to a will. Markings, tears, or removed staples
          make judges double-check that pages weren't added or removed after signing.
        </p>
      </div>

      <div className="flex flex-col rounded-lg border border-primary overflow-clip">
        <div className="flex flex-col gap-2 bg-white border-b border-primary p-6">
          <p className="text-sm font-semibold">Do not try to repair or restaple the document</p>
          <p className="text-sm text-secondary tracking-[-0.28px]">
            Keep the will exactly as it is right now. Adding new staples, tape, or paperclips can
            cause further issues with the court clerk.
          </p>
        </div>
        <div className="flex flex-col gap-2 bg-white p-6">
          <p className="text-sm font-semibold">A simple explanation form is required</p>
          <p className="text-sm text-secondary tracking-[-0.28px]">
            You will need to submit a short statement (called an affidavit of condition) telling
            the court how the document was stored and why the damage or changes happened. We will
            help you write this down.
          </p>
        </div>
      </div>

      <AttorneyCta
        title="Questions? Talk to an attorney"
        body="If pages are missing, heavily marked, or unstapled, a brief consultation with an attorney can ensure your explanation satisfies the court clerk on the first attempt."
      />
    </div>
  );
};
